<template>
  <div class="tuk-loader">
    <div class="loade" @click="hide">
      <!-- <img class="loade__animated" src="https://image.flaticon.com/icons/svg/561/561071.svg" />
      <img src="https://image.flaticon.com/icons/svg/560/560969.svg" /> -->
      <div v-if="isPicante()">
        <img class="loade__animated" src="/img/icons/picante_loading.svg" />
        <img class="tuk-grey" src="/img/icons/picante_loading_grey.svg" />
      </div>
      <div v-else>
        <img class="loade__animated" src="/img/icons/tuk-loading-color.png" />
        <img class="tuk-grey" src="/img/icons/tuk-loading-grey.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TukLoader",
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => this.$emit("check"), 1500); // check ever 1.25s
    setTimeout(() => this.hide(), 5000); // hide if stuck loading too long
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style scoped>
.tuk-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background-color: #966ac45a; */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
}
.loade {
  position: relative;
  /* width: 40%; */
  width: 150px;
  will-change: transform, opacity;
  transform: translateZ(0);
}
.loade:before {
  content: "";
  padding-top: 100%;
  display: block;
}
.loade__animated {
  clip-path: inset(100% 0 0 0);
  animation: loader 3s ease infinite;
  will-change: transform, opacity;
  filter: drop-shadow(1px 1px 5px grey);
  /* opacity: 0.95; */
}
.loade img {
  /* width: 60%; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-grey {
  filter: drop-shadow(0px 0px 1px rgb(140, 140, 140));
}
@keyframes loader {
  0% {
    clip-path: inset(100% 0 0 0);
  }
  50% {
    clip-path: inset(0 0 0 0);
  }
  100% {
    clip-path: inset(100% 0 0 0 0);
  }
}
</style>

<style>
/* dark theme: blue glow (splash screen palette) instead of the grey shadow */
html[data-theme="dark"] .tuk-loader .loade__animated {
  filter: drop-shadow(0 0 10px rgba(38, 147, 218, 0.75));
}

html[data-theme="dark"] .tuk-loader .tuk-grey {
  filter: drop-shadow(0 0 1px rgba(38, 147, 218, 0.9));
}
</style>
